module.exports = __webpack_public_path__ + "media/components/home/creator-community/img/avecalvar-avatar-9e6ef2d17d7bd25dda9d7ed716916745.jpg";